const status = [
    {text: 'settlements.status.inProgress', value: 'IN_PROGRESS'},
    {text: 'settlements.status.completed', value: 'COMPLETED'},
    {text: 'settlements.status.sentToSponsor', value: 'SENT_TO_SPONSOR'},
    {text: 'settlements.status.rejectedBySponsor', value: 'REJECTED_BY_SPONSOR'},
    {text: 'settlements.status.approvedBySponsor', value: 'APPROVED_BY_SPONSOR'},
    {text: 'settlements.status.error', value: 'ERROR'}
]

const sponsors = [
    {
        text: 'settlements.sponsors.DO.humano',
        value: 'do-humano'
    },
    {
        text: 'settlements.sponsors.DO.universal',
        value: 'do-universal'
    },
    {
        text: 'settlements.sponsors.DO.primera',
        value: 'do-primera'
    },
]

const orderBy = [
    {
        text: 'home.order.createdAt',
        value: 'createdAt',
        order: 'desc'
    },
    {
        text: 'home.order.beneficiaryName',
        value: 'beneficiaryName',
        order: 'asc'
    },
]

const currencySymbols = [
    {
        code: "DOP",
        symbol: "$"
    }
]



export {
    status,
    orderBy,
    sponsors,
    currencySymbols
}